import React from "react";
import "./about.scss";
import logo from "../../media/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import { faSolarPanel } from "@fortawesome/free-solid-svg-icons";
import { faCheckToSlot } from "@fortawesome/free-solid-svg-icons";
import { faDoorOpen } from "@fortawesome/free-solid-svg-icons";

const about = () => {
  const buttonwaabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=+6282297791381&text=Halo%20Vania,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(promo)%20https://marketing-citralandsurabaya.com/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="container-about">
      <div className="logo-about">
        <img className="gambar-logo" src={logo} alt="logo-citraland-surabaya" />
      </div>

      <div className="container-deskripsi">
        <div className="deskripsi-about">
          <div className="judul-deskripsi">
            <h1>Why Choose CitraLand Utara</h1>
          </div>
          <div className="deskripsi">
            Cirtaland Utara adalah proyek pengembangan properti milik Grup
            Ciputra yang terletak di Surabaya, Indonesia. Ini adalah kawasan
            hunian dan komersial. Kawasan ini menawarkan hunian eksklusif,
            kontemporer, ramah lingkungan, dan pintar dengan fasilitas yang
            memenuhi kebutuhan keluarga.
          </div>
          <div className="button-wa-about">
            <button onClick={buttonwaabout} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Dapatkan Promo Terbaik
            </button>
          </div>
        </div>
      </div>

      <div className="feature">
        <div className="icon">
          <div className="security">
            <FontAwesomeIcon color="white" size="3x" icon={faUserShield} />
            <div className="des-security"> 24 Hour Security </div>
          </div>
          <div className="security">
            <FontAwesomeIcon color="white" size="3x" icon={faSolarPanel} />
            <div className="des-security"> Solar Panel </div>
          </div>
          <div className="security">
            <FontAwesomeIcon color="white" size="3x" icon={faCheckToSlot} />
            <div className="des-security"> Utility Underground </div>
          </div>
          <div className="security">
            <FontAwesomeIcon color="white" size="3x" icon={faDoorOpen} />
            <div className="des-security"> One Gate System </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default about;
